import { render, staticRenderFns } from "./RewardsSignupSidePanel.vue?vue&type=template&id=e36321cc"
import script from "./RewardsSignupSidePanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./RewardsSignupSidePanel.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./RewardsSignupSidePanel.vue?vue&type=style&index=0&id=e36321cc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports